import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import dateFormat from 'dateformat';
import BoltLoader from './loaders/boltloader';
import "./BlogDetail.css"; 

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/articles/${id}/`)
      .then((response) => response.json())
      .then((data) => setBlog(data))
      .catch((error) => console.error("Error fetching blog:", error));
  }, [id]);

  if (!blog) {
    return (
      <div className="loader-container-full">
        <BoltLoader
          className={"loaderbolt"}
          boltColor={"#fa6616"}
          backgroundBlurColor={"#E0E7FF"}
        />
      </div>
    );
  }

  return (
    <div className="blog-page-wrapper">
      <div className="container">
        
        {/* Navigation Breadcrumb */}
        <div className="blog-nav">
          <Link to="/blogs" className="back-link">
            <span className="arrow">←</span> Back to Articles
          </Link>
        </div>

        <article className="blog-article">
          {/* Header Section */}
          <header className="blog-header">
            <div className="blog-category">
              <span className="badge-category">{blog.specialist || 'Medical Insights'}</span>
            </div>
            
            <h1 className="blog-title">{blog.title}</h1>
            
            <div className="blog-meta-wrapper">
              <div className="meta-item">
                <span className="meta-icon">👤</span>
                <span className="meta-text">By <strong>{blog.author}</strong></span>
              </div>
              <div className="meta-divider"></div>
              <div className="meta-item">
                <span className="meta-icon">📅</span>
                <span className="meta-text">{dateFormat(blog.datetime, "mmmm dS, yyyy")}</span>
              </div>
            </div>
          </header>

          {/* Featured Image */}
          <div className="blog-hero-image">
            <img 
              src={blog.poster || "https://via.placeholder.com/800x400"} 
              alt={blog.title} 
            />
          </div>

          {/* Main Content */}
          <div 
            className="blog-content-body" 
            dangerouslySetInnerHTML={{ __html: blog.content }} 
          />

          {/* Article Footer */}
          <footer className="blog-footer">
            <div className="share-prompt">
              <p>Found this helpful? Share it with others.</p>
            </div>
          </footer>
        </article>

      </div>
    </div>
  );
};

export default BlogDetail;